import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sun } from 'lucide-react';
import { useLanguage } from './LanguageContext';

const Hero = () => {
  const { language, t, getLocalizedPath } = useLanguage();

  return (
    <section className="relative min-h-screen w-full flex items-center justify-center md:justify-end px-6 md:px-16 lg:px-24 overflow-hidden pt-24 pb-20 md:py-20">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-no-repeat bg-[center_top] max-[699px]:bg-[position:36%_70%]"
        style={{
          backgroundImage: 'url("https://assets.auxodev.dk/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/koorestol4.png")'
        }}
      >
        {/* Subtle dark overlay with radial gradient targeting the text area */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(0,0,0,0.18)_0%,rgba(0,0,0,0.06)_50%,transparent_100%)] md:bg-[radial-gradient(circle_at_80%_50%,rgba(0,0,0,0.22)_0%,rgba(0,0,0,0.08)_55%,transparent_100%)]"></div>
      </div>

      {/* Text Container (Centered internally, pushed right on desktop) */}
      <div className="relative z-10 max-w-2xl text-center flex flex-col items-center">
        
        <h1 className="font-serif text-[2.5rem] sm:text-[3.75rem] md:text-[4.5rem] text-white leading-[1.1] font-normal tracking-tight drop-shadow-[0_4px_16px_rgba(0,0,0,0.7)]">
          {language === 'da' ? (
            <>Handicapvenlige<br />rejser</>
          ) : (
            <>Accessible<br />Holidays</>
          )}
        </h1>

        {/* Decorative Divider */}
        <div className="flex items-center justify-center w-full gap-6 my-6 md:my-8">
          <div className="h-[2px] sm:h-[3px] w-24 sm:w-36 md:w-48 bg-gradient-to-r from-transparent via-[#D2B98C] to-transparent"></div>
          <Sun className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 text-[#D2B98C] animate-[spin_30s_linear_infinite] drop-shadow-[0_0_8px_rgba(210,185,140,0.5)]" />
          <div className="h-[2px] sm:h-[3px] w-24 sm:w-36 md:w-48 bg-gradient-to-r from-transparent via-[#D2B98C] to-transparent"></div>
        </div>

        <p className="font-sans text-[13px] sm:text-[15px] md:text-[17px] text-[#F7EFE2] font-medium tracking-[0.3em] uppercase mb-8 drop-shadow-sm">
          {language === 'da' ? 'FERIER MED RO I MAVEN' : 'HOLIDAYS WITH PEACE OF MIND'}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 mt-[34px]">
          <Link 
            to={getLocalizedPath('destinations', language)} 
            className="group relative overflow-hidden bg-[#99A18C] text-white px-6 py-2.5 rounded-full font-bold transition-all shadow-xl hover:shadow-[#99A18C]/40 hover:-translate-y-1 text-xs md:text-sm uppercase tracking-wider flex items-center justify-center"
          >
            <span className="relative z-10 flex items-center justify-center">
              {language === 'da' ? 'Se alle rejsemål' : 'Explore Destinations'}
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </Link>
          <Link 
            to={getLocalizedPath('quote', language)} 
            className="group relative overflow-hidden bg-[#99A18C] text-white px-6 py-2.5 rounded-full font-bold transition-all shadow-xl hover:shadow-[#99A18C]/40 hover:-translate-y-1 text-xs md:text-sm uppercase tracking-wider flex items-center justify-center"
          >
            {t('nav_quote')}
          </Link>
        </div>
      </div>

      {/* Subtle scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce hidden md:block">
        <div className="w-[1px] h-10 bg-white/40"></div>
      </div>
    </section>
  );
};

export default Hero;
